export class CompanyPosition {
    public static CompanyPositionList: Array<any> = [
        { name: 'CEO', value: 'CEO' },
        { name: 'Founder', value: 'Founder' },
        { name: 'Co-Founder', value: 'Co-Founder' },
        { name: 'Secretary', value: 'Secretary' },
        { name: 'Executive Director', value: 'Executive Director' },
    ];
}
